export default "__VITE_ASSET__b7ee1119__"